import React, { useEffect, useMemo, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { Box, Tab, Tabs, Typography } from '@mui/material';

import { LayoutBase } from '../../../../../layouts';
import { ToolsDamInformation, DamInfoTable } from '../../../../../components/custom';
import { VMenu } from '../../../../../components/shared';
import { UseDebounce } from '../../../../../hooks';
import { FileServices, IFileList} from '../../../../../services/api/files/FileServices';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
  }
  
  function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  
  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

export const SpecialSafetyInspectionReport = () => {

    const { id = 'novo' } = useParams<'id'>();
    const { debouce } = UseDebounce();
    const [rows, setRows] = useState<IFileList[]>([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const [totalCount, setTotalCount] = useState(0);
    const [value, setValue] = React.useState(0);


    const busca = useMemo(() => {
        return searchParams.get('busca') || '';
    }, [ searchParams]);

    const pagina = useMemo(() => {
        return Number(searchParams.get('pagina') || '1');
    }, [ searchParams]);


    useEffect(() => {
        debouce(() => {
            FileServices.getAll(pagina, busca)
            .then((result) => {
                if(result instanceof Error){
                    alert(result.message);
                }else{
                    setTotalCount(result.totalCount);
                    setRows(result.data);
                    console.log(result);
                }
            });
        });
    }, [busca, pagina]);


    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };
      
    return (
        <LayoutBase title='Informações'
            tollBar={
                <ToolsDamInformation />
            }
        >   
            <Box width={'100%'}>
                <VMenu id={id}/>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }} justifyContent={'space-around'} display={'flex'}>
                    <Tabs value={value} onChange={handleChange}>
                        <Tab label="RESUMO EXECUTIVO DOS RELATÓRIOS DE INSPEÇÃO DE SEGURANÇA ESPECIAL" {...a11yProps(0)} />
                        <Tab label="HISTÓRICO" {...a11yProps(1)} />
                        <Tab label="ARQUIVOS" {...a11yProps(2)} />   
                    </Tabs>
                </Box>
                <CustomTabPanel value={value} index={0}>

                </CustomTabPanel>
                <CustomTabPanel value={value} index={1}>
                    
                </CustomTabPanel>
                <CustomTabPanel value={value} index={2}>
                  <DamInfoTable
                    rows={rows}
                    columns={[
                        {label: 'título', key: 'file_name'},
                        {label: 'descrição', key: 'description'},
                        {label: 'Datas de Arquivo', key: ['insert_date', 'issue_date'] },
                    ]}
                    actions={{
                        view: {label: 'Visualizar', onClick: () => console.log('teste'), variant: 'text'},
                        download: {label: 'Download', onClick: () => console.log('teste'), variant: 'text'},
                        email: {label: 'Enviar por e-mail', onClick: () => console.log('teste'), variant: 'outlined'},
                        edit: {label: 'Editar', onClick: () => console.log('teste'), variant: 'outlined'},
                        delete: {label: 'Excluir', onClick: () => console.log('teste'), variant: 'contained'}
                    }}
                    />
                    
                      
                </CustomTabPanel>
            </Box>
        </LayoutBase>
    );
};


